import Cookies from "js-cookie";

export default function loginModal() {
  // show modal
  document.querySelectorAll(".show-login").forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();

      document.querySelectorAll(".login-modal").forEach((el) => {
        el.classList.add("open");
      });

      document.querySelectorAll("body").forEach((el) => {
        el.classList.add("modal-open");
      });

      const uId = Cookies.get("savedUserName");
      if (uId) {
        document.querySelector("#login-user-id").value = uId;
        document.querySelector("#login-remember-me").checked = true;
        document.querySelector(".login-modal__blocks").classList.add("open");
      }

      MicroModal.show("modal-1");
    });
  });

  // close modal
  document
    .querySelectorAll(".login-modal, .login-modal__content-close")
    .forEach((el) => {
      el.addEventListener("click", function (e) {
        e.preventDefault();

        document.querySelectorAll(".login-modal").forEach((el) => {
          el.classList.remove("open");
          el.classList.add("fade-out");
        });

        document.querySelectorAll("body").forEach((el) => {
          el.classList.remove("modal-open");
        });

        document
          .querySelectorAll(".login-modal__blocks")[0]
          .classList.remove("open");

        var errorMsg = document.querySelector(".login-modal__block-form-error");
        errorMsg.style.display = "none";
        document.querySelector("#login-user-id").value = "";

        MicroModal.close("modal-1");
      });
    });

  document.querySelectorAll(".login-modal__content").forEach((el) => {
    el.addEventListener("click", function (e) {
      e.stopPropagation();
    });
  });

  document.querySelectorAll(".login-modal__block a").forEach((el) => {
    el.addEventListener("click", function (e) {

      if (el.classList.contains('redirect-link')) {
          window.location.href = el.href;
          return;
      }

      e.stopPropagation();
      e.preventDefault();

      var formContainer = el.nextElementSibling;
      var form = document.getElementById('login-form');
      formContainer.appendChild(form);

      el.parentNode.parentNode.parentNode.classList.remove("open");
      
      document.querySelectorAll('.login-modal__block.open').forEach((el) => {
        el.classList.remove('open');
      });

      setTimeout(function() {
        el.parentNode.parentNode.parentNode.classList.add("open");
        el.parentNode.parentNode.classList.add("open");
        document.querySelector("#login-user-id").focus();
      }, 50);
  

      /*var parentOpen = Array.from(
        el.parentNode.parentNode.parentNode.classList
      ).indexOf("open");

      if (parentOpen > -1) {
        el.parentNode.parentNode.parentNode.classList.remove("open");
        document.querySelector("#login-user-id").value = "";
      } else {
        el.parentNode.parentNode.parentNode.classList.add("open");
        document.querySelector("#login-user-id").focus();
      }*/
    });
  });

  document.querySelectorAll(".login-modal__block-form input").forEach((el) => {
    el.addEventListener("input", function (e) {
      var form = document.getElementById('login-form');
      var formError = form.querySelector(".input-group__error");
      formError.innerHTML = "";
      formError.classList.remove("has-error");

      var errorMsg = form.querySelector(".login-modal__block-form-error");
      errorMsg.style.display = "none";
    });
  });

  // form cancel
  document.querySelectorAll(".login-modal__block-form-cancel").forEach((el) => {
    el.addEventListener("click", function (e) {
      e.stopPropagation();
      e.preventDefault();

      document.querySelectorAll(".login-modal__blocks").forEach((el) => {
        el.classList.remove("open");
        document.querySelector("#login-user-id").value = "";
      });

      document.querySelectorAll(".login-modal__block").forEach((el) => {
        el.classList.remove("open");
      });
    });
  });

  // forget username if remember me is unchecked
  document
    .querySelector("#login-remember-me")
    .addEventListener("change", (e) => {
      if (!e.target.checked) {
        Cookies.remove("savedUserName");
      }
    });

  // form continue
  document.querySelectorAll(".login-modal__block-form-submit").forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();

      var form = document.getElementById('login-form');

      var constraints = {
        "user-id": {
          presence: {
            message: "User ID cannot be blank.",
          },
        },
      };

      var formError = form.querySelector(".input-group__error");
      var errors = validate(form, constraints, { fullMessages: false });
      //console.log('errors', errors);

      if (errors) {
        formError.innerHTML = errors["user-id"][0];
        formError.classList.add("has-error");

        var errorMsg = form.querySelector(".login-modal__block-form-error");
        errorMsg.style.display = "none";
      } else {
        formError.innerHTML = "";
        formError.classList.remove("has-error");
        // submit

        var userId = document.getElementById("login-user-id").value;
        doLogin(userId);
      }
    });
  });

  document
    .getElementById("login-user-id")
    .addEventListener("keypress", function (event) {
      if (event.keyCode === 13) {
        //console.log('enter');

        document.querySelectorAll(".login-modal__block-form-submit")[0].click();
      }
    });

  function doLogin(userId) {
    var httpRequest2 = new XMLHttpRequest();

    if (document.querySelector("#login-remember-me:checked") !== null) {
      Cookies.set("savedUserName", userId);
    }


    httpRequest2.onreadystatechange = function () {
      if (httpRequest2.readyState === XMLHttpRequest.DONE) {
        if (httpRequest2.status === 200) {
          console.log('success', httpRequest2.responseText);

          var data = JSON.parse(httpRequest2.responseText);
          var system = data.CallResults.System;

          if (system == "nfs") {
            window.location.href = "https://investor.wealthscape.com/msiebert/investor-index.html";
          }
          else if (system == "esop") {
            window.location.href = "https://stocx.investor.trading2.fast-trade.com/siebertnet/login.do";
          }
          else if (system == "etna" || system == "aspire") {
            //window.location.href = process.env.TRADER_URL;
            window.location.href = "https://stocx.investor.trading2.fast-trade.com/siebertnet/login.do";
          }
          else {
            //window.location.href = process.env.REGISTER_URL + "?new";
            window.location.href = "https://stocx.investor.trading2.fast-trade.com/siebertnet/login.do";
          }
        } else {
          console.log('login error', httpRequest2.responseText);
        }
      }
    };

    
    httpRequest2.open(
      "GET",
      "/api/GetSiebertAccountLookup?id=" + encodeURIComponent(userId),
      true
    );
    //httpRequest2.setRequestHeader ("Authorization", "Basic " + btoa("SiebertAccountLookupApiUser" + ":" + "hA17I4$2Z!ekJ$SuT9SqTCjVyyKfpdCzIB&6ONgpI&"));
    httpRequest2.send();

    /*
    var httpRequest = new XMLHttpRequest();

    httpRequest.onreadystatechange = function () {
      if (httpRequest.readyState === XMLHttpRequest.DONE) {
        if (httpRequest.status === 200) {
          //console.log(httpRequest.responseText);
          var data = JSON.parse(httpRequest.responseText);

          if (data.System == "nfs") {
            window.location.href =
              "https://investor.wealthscape.com/msiebert/investor-index.html";
          } else if (data.System == "aspire") {
            window.location.href =
              "https://stocx.investor.trading2.fast-trade.com/siebertnet/";
          } else {
            //window.location.href = 'https://www.siebertnet.com/not-recognized';

            var errorMsg = document.querySelector(
              ".login-modal__block-form-error"
            );
            errorMsg.style.display = "block";
          }
        } else {
          //console.log('login error', httpRequest.responseText);

          var errorMsg = document.querySelector(
            ".login-modal__block-form-error"
          );
          errorMsg.style.display = "block";
        }
      }
    };

    httpRequest.open(
      "GET",
      "https://api.siebertnet.com/api/accountlookup/" +
        encodeURIComponent(userId),
      true
    );
    httpRequest.send();*/
  }
}
